import api from '@/helpers/api';
import { findFlowById } from '@/components/business/flows/flow.helpers';

export default {
  getFlowsDefinitions({ commit, rootState }) {
    const requestUrl = 'flows/definitions';
    const request = api('GET', requestUrl, { organisation_uid: rootState.organisation.currentOrganisation.id }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FLOWS_DEFINITIONS', response.data);
        }
      });
  },
  createFlow({ commit, rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/create`;
    const request = api('POST', requestUrl, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          // Increment total flows count in flows meta
          commit('INCREMENT_TOTAL_FLOWS');
          // Add flow to list of flows
          commit('ADD_FLOW', response.data);
        }
      });
    return request;
  },
  deleteFlow({ commit, rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const request = api('DELETE', requestUrl, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('DELETE_FLOW', payload.flowId);
        }
      });
    return request;
  },
  updateFlowName({ rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const request = api('PUT', requestUrl, { name: payload.name }, null, 'w');
    return request;
  },
  updateFlowOrder({ rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const request = api('PUT', requestUrl, { order: payload.order }, null, 'w');
    return request;
  },
  updateFlowFrequency({ rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const data = {
      params: {
        trigger_frequency: {
          type: payload.type,
          value: payload.value,
        },
      },
    };
    const request = api('PUT', requestUrl, data, null, 'w');
    return request;
  },
  updateFlow({ commit, rootState }, payload) {
    // console.log('change', JSON.parse(JSON.stringify(payload)));
    // return;
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const data = {
      blocks: payload.blocks,
    };

    // Add skeleton block before the request finishes successfully
    commit('TEMP_FLOW_DATA', payload.blocks);

    const request = api('PUT', requestUrl, data, null, 'w');
    request
      .then((response) => {
        commit('UPDATE_FLOW_DATA', response.data.flow_data);
      })
      .catch((error) => {
        commit('ERROR_UPDATING_FLOW', error.response || {});
      });
    return request;
  },
  updateFlowData({ commit }, data) {
    commit('UPDATE_FLOW_DATA', data);
  },
  moveSiblingFlowBlock({ commit, state, dispatch }, data) {
    commit('BACKUP_FLOW_DATA');
    let response = null;
    const { previousBlock } = findFlowById(state.flowData.blocks, data.parentNodeId);
    // find target flowId
    if (previousBlock) {
      const targetFlowIndex = previousBlock.child_flows.findIndex(f => f.blocks.some(b => b.block_id === data.node.id));
      if (targetFlowIndex !== -1) {
        // serialize data
        const flow = JSON.parse(JSON.stringify(previousBlock.child_flows[targetFlowIndex]));
        // Remove the target flow from the previous position
        previousBlock.child_flows.splice(targetFlowIndex, 1);
        // Add the target flow to the new position
        previousBlock.child_flows.splice(targetFlowIndex + data.direction, 0, flow);
        // Reset order values
        previousBlock.child_flows.forEach((flow, i) => {
          flow.order = i;
        });

        response = dispatch('updateFlow', {
          numberId: state.flowData.business_uid,
          flowId: state.flowData.flow_id,
          blocks: state.flowData.blocks,
        });
      }
    }
    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  updateFlowPositions({ commit, state, dispatch }, data) {
    commit('BACKUP_FLOW_DATA');
    let response = null;
    const { previousBlock: previous, parentBlock: previousParent } = findFlowById(state.flowData.blocks, data.target);
    const { previousBlock: dropped, parentBlock: droppedParent } = findFlowById(state.flowData.blocks, data.dropped);

    // Remove dropped from previous location
    if (dropped && droppedParent) {
      const droppedIndex = droppedParent.findIndex(b => b.block_id === data.dropped);
      if (droppedIndex !== -1) {
        droppedParent.splice(droppedIndex, 1);
        // Reset order values
        droppedParent.forEach((block, i) => {
          block.order = i;
        });
      }
    }

    // Add dropped to new location
    if (previous && previousParent) {
      const targetIndex = previousParent.findIndex(b => b.block_id === data.target);
      if (targetIndex !== -1) {
        if (data.above) {
          previousParent.splice(targetIndex, 0, dropped);
        } else {
          previousParent.splice(targetIndex + 1, 0, dropped);
        }
        // Reset order values
        previousParent.forEach((block, i) => {
          block.order = i;
        });
      }
    }

    dropped.block_id = '';
    response = dispatch('updateFlow', {
      numberId: state.flowData.business_uid,
      flowId: state.flowData.flow_id,
      blocks: state.flowData.blocks,
    });

    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  addFlowBlock({ commit, state, dispatch }, data) {
    commit('BACKUP_FLOW_DATA');
    // console.log('addFlowBlock', data);
    // return;
    let response = null;
    // Find parent block
    const { previousBlock, parentBlock, index } = findFlowById(state.flowData.blocks, data.sibling && data.targetNodeId ? data.targetNodeId : data.parentId);
    // console.log('addFlowBlock', previousBlock, parentBlock, index);
    if (parentBlock && previousBlock) {
      if (data.sibling && data.targetNodeId) {
        const siblingFlow = {
          blocks: [data.block],
        };
        siblingFlow.blocks[0].order = 0;
        if (data.sibling === 'after') {
          previousBlock.child_flows.push(siblingFlow);
          previousBlock.params.split_number = previousBlock.child_flows.length;
        } else if (data.sibling === 'before') {
          previousBlock.child_flows.splice(0, 0, siblingFlow);
          previousBlock.params.split_number = previousBlock.child_flows.length;
        }
        // Reset order values
        previousBlock.child_flows.forEach((block, i) => {
          block.order = i;
        });
      } else {
        parentBlock.splice(index + 1, 0, data.block);
        // Reset order values
        parentBlock.forEach((block, i) => {
          block.order = i;
        });
      }

      response = dispatch('updateFlow', {
        numberId: state.flowData.business_uid,
        flowId: state.flowData.flow_id,
        blocks: state.flowData.blocks,
      });
    }

    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  editFlowBlock({ commit, state, dispatch }, data) {
    // console.log('editFlowBlock', data);
    // return;
    let response = null;
    // Find parent block
    const { previousBlock } = findFlowById(state.flowData.blocks, data.blockId);
    if (previousBlock) {
      previousBlock.params.elements = data.block.params.elements;
      // NOTE - this is a custom field for the reply block
      // TODO - make it generic on rewrite
      if (data.block.params.seconds) {
        previousBlock.params.seconds = data.block.params.seconds;
      }
      // NOTE - this is a custom field for the AiAssistant block
      // TODO - make it generic on rewrite
      if (data.block.params.user_uid) {
        previousBlock.params.respond_upon_assignment = data.block.params.respond_upon_assignment;
        previousBlock.params.user_uid = data.block.params.user_uid;
      }
      delete previousBlock.block_id;
      response = dispatch('updateFlow', {
        numberId: state.flowData.business_uid,
        flowId: state.flowData.flow_id,
        blocks: state.flowData.blocks,
      });
    }

    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  removeFlow({ commit, state, dispatch }, payload) {
    let response = null;
    // Find parent block
    const { previousBlock, parentBlock, index } = findFlowById(state.flowData.blocks, payload.parentNodeId);

    if (previousBlock) {
      // find target flowIndex
      const targetFlowIndex = previousBlock.child_flows.findIndex(f => f.blocks.some(b => b.block_id === payload.node.id));
      if (targetFlowIndex !== -1) {
        // Remove the target flow from the previous position
        previousBlock.child_flows.splice(targetFlowIndex, 1);
        // Reset order values
        previousBlock.child_flows.forEach((flow, i) => {
          flow.order = i;
        });
        previousBlock.params.split_number = previousBlock.child_flows.length;

        response = dispatch('updateFlow', {
          numberId: state.flowData.business_uid,
          flowId: state.flowData.flow_id,
          blocks: state.flowData.blocks,
        });
      }
    }

    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  removeFlowBlock({ commit, state, dispatch }, params) {
    let response = null;
    // Find parent block
    const { previousBlock, parentBlock, index } = findFlowById(state.flowData.blocks, params.node.id);

    if (parentBlock) {
      if (parentBlock.length === 1 && parentBlock[0].block_id === params.node.id && previousBlock.block_id === params.node.id) {
        const { previousBlock } = findFlowById(state.flowData.blocks, params.parentNodeId);
        previousBlock.child_flows.forEach((block) => {
          block.blocks = block.blocks.filter(b => b.block_id !== params.node.id);
        });
        previousBlock.child_flows = previousBlock.child_flows.filter(b => b.blocks.length > 0);
        previousBlock.params.split_number = previousBlock.child_flows.length;
      } else {
        parentBlock.splice(index, 1);
        // Reset order values
        parentBlock.forEach((block, i) => {
          block.order = i;
        });
      }
      response = dispatch('updateFlow', {
        numberId: state.flowData.business_uid,
        flowId: state.flowData.flow_id,
        blocks: state.flowData.blocks,
      });
    }

    if (response) {
      return response;
    }
    return new Promise((resolve, reject) => reject());
  },
  getOrganisationFlows({ commit }, payload) {
    const requestUrl = `flows/organisation/${payload.organisationId}`;
    const request = api('GET', requestUrl, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_FLOWS', response.data);
          commit('SET_ORGANISATION_FLOWS_META', response.data.meta);
        }
      });
  },
  fetchFlowData({ commit, rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const request = api('GET', requestUrl, null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_FLOW_DATA', response.data);
        }
      });
    return request;
  },
  activateFlow({ rootState }, payload) {
    const requestUrl = `flows/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/flow/${payload.flowId}`;
    const request = api('PUT', requestUrl, { active: payload.active }, null, 'w');
    return request;
  },
  clearOrganisationFlows({ commit }) {
    commit('CLEAR_FLOWS');
  },
  setBlocksCount({ commit }, payload) {
    commit('SET_SPLIT_BLOCKS_COUNT', payload);
  },
  setToggleElement({ commit }, payload) {
    commit('SET_TOGGLE_ELEMENT', payload);
  },
  removeToggleElement({ commit }, name) {
    commit('REMOVE_TOGGLE_ELEMENT', name);
  },
  clearToggleElements({ commit }) {
    commit('CLEAR_TOGGLE_ELEMENTS');
  },
};
